/**
 * Created by admin on 2018/5/24.
 */
// 注意：一定是 exports，不是 export，否則會報錯，報錯資訊是下列的中的內容不是 string
module.exports = {
    zh_en: {
        text: '中文/English'
    },
    logo: {
        src: 'static/logo.png'
    },
    menu: {
        Sitemap:'網站導航',
        Home: '首頁',
        Features: '產品特點',
        Products: '產品',
        FAQ: '常見問題',
        Blog: '文章',
        Contact: '聯繫我們',
        About: '關於我們'
    },
    contactInfo:{
        title: '聯繫資訊',
        email: '郵箱: salesph@nelsoft.com.ph / sales@nelsoft.com.ph',
        cntel: '電話 : +63-917-8836968',
        entel: '網址: www.lettuce.com.ph',
        contact: '聯繫人: LAW Roger',
        address: '地址: 5th Floor #41 J. Mariano St., Corner EDSA Barangay 95, Caloocan City 1400',
        wechat: '微信',
        wechatMsg: '仅支持中国客户联系',
    },
    header: {
        tit1: '收銀 POS',
        titSub1: {
            text1: '收銀員',
            text2: '訂購機器',
            text3: '自助機器',
            text4: '列印機',
        },
        tit2: '商戶後臺',
        titSub2: {
            text1: '易於管理',
            text2: '多台設備同時訂購',
            text3: '提高廚房效率',
            text4: '多種付款方式',
        },
    },
    home: {
        moreBtn: '更多',
        banner:{
            banner1:{
                bannerText: 'BIR 認證軟體',
                bannerDetail: '菲律賓國稅局BIR認證軟體，每台收銀機申請正規收銀許可證。',
            },
            banner2: {
                bannerText: '商場合作',
                bannerDetail: 'LETTUCE POS 已接通兩大商場營業資料API介面 更方便入駐該商場客戶使用。',
            }
        },
        con1: {
            tit1: '政府認證',
            tit2: '豐富的平臺',
            tit3: '適用場景豐富',
            tit4: '遠端系統管理系統',
            con1: '菲律賓稅務局認證收銀軟體',
            con2: '多種平臺自由配置：收銀機、Pad點餐機、自助點餐機，支持中英文雙語切換',
            con3: '支援高檔酒樓、連鎖速食、小吃奶茶、酒吧、自助餐廳等',
            con4: '一人可管理多家門店，遠端設置餐檯、功能表、支付方式，收銀機資料與雲端同步',
        },
        con2: {
            title1: '收銀 POS',
            title2: '商戶後臺',
            table1: {
                title1: '01 餐檯輕鬆管理',
                titleSub1: '檯位安排忙不過來？',
                con1: 'lettuce針對不同的訂單狀態在餐檯的顯示效果上做了不同的設計，店內用餐情況一目了然。',
                title2: '02 多台設備同時點餐',
                titleSub2: '客人太多點餐手忙腳亂？',
                con2: 'lettuce收銀機可同時配合多台平板點餐機，服務員可攜設備隨時隨地為客戶點餐，數據即時同步，協作方便。',
                title3: '03 內場快速出餐',
                titleSub3: '廚房一忙就出錯菜？',
                con3: 'lettuce擁有強大的協作能力，不僅能設置後廚的列印方式，並且能將下單、改單、加菜等資訊即時傳輸到後廚印表機上，減少出錯機率。',
                title4: '04 多種支付方式',
                titleSub4: '想提供多種支付方式又怕結算太麻煩？',
                con4: 'lettuce可設置多種支付方式，系統將結合優惠抵扣、稅收、服務費等資訊自動換算應收金額，讓前臺收銀更加方便快捷。',
                title5: '05 口味、加料隨心選擇',
                titleSub5: '奶茶口味、加料一樣，點餐很混亂？',
                con5: '可以根據商品特徵，選擇相應的規格、屬性、加料，下單後同步列印標籤，出單簡單又高效。',
                title6: '06 多種促銷活動',
                titleSub6: '節假日活動多，行銷跟不上？',
                con6: '後臺可設置多種促銷方式，並選擇活動的具體時間。活動期間內收銀員選擇活動，帳單便會自動計算金額，並體現在稅單和後臺的統計表中。',
                title7: '07 交換班和現金管理',
                titleSub7: '員工上下班，現金核對困難？',
                con7: '每天上班提交收銀員和現金資料，交班後再次清點，系統會核算出應收金額和誤差金額，管理一目了然。',
                title8: '08 支持離線',
                titleSub8: '餐廳網路環境不好，信號中斷怎麼辦？',
                con8: 'Lettuce 收銀機擁有超大存儲空間，支援本地數據存儲和離線操作，不懼網路信號問題。在有網路的時候 ，同步數據，即可實現雲端管理。',
                title9: '09 支持中英文',
                titleSub9: '特殊餐廳需要中英文？',
                con9: '所有設備和後臺都支援中英文切換，方便閱讀和查看；標籤和單據的列印也能同時中英文，功能表展示更直觀。',
            },
            table2: {
                title1: '01 店鋪運營統計',
                titleSub1: '無法準確分析店鋪營收情況？',
                con1: 'Lettuce後臺系統對各類訂單明細有詳細的記錄，資料視覺化圖表展示，營收狀況一目了然。',
                title2: '02 員工許可權管理',
                titleSub2: '員工操作失誤影響店鋪運營？',
                con2: 'Lettuce後臺系統可對不同工種的員工帳號進行詳細的許可權設置，避免越級誤操作，保證店鋪正常運行。',
                title3: '03 優惠活動管理',
                titleSub3: '優惠促銷成本算不清楚？',
                con3: 'Lettuce後臺系統優惠活動自訂程度高，前端收銀結合已選的優惠活動自動換算金額，優惠活動資料也可在後臺查看詳細情況。',
                title4: '04 多門店管理',
                titleSub4: '多家店鋪管理太麻煩？',
                con4: 'Lettuce後臺系統可實現多門店統一管理，共用優惠活動、商品資訊等，免去重複錄入資訊的煩惱。',
                title5: '05 口味、加料隨心選擇',
                titleSub5: '奶茶口味、加料一樣，點餐很混亂？',
                con5: '可以根據商品特徵，選擇相應的規格、屬性、加料，下單後同步列印標籤，出單簡單又高效。',
                title6: '06 多種促銷活動',
                titleSub6: '節假日活動多，行銷跟不上？',
                con6: '後臺可設置多種促銷方式，並選擇活動的具體時間。活動期間內收銀員選擇活動，帳單便會自動計算金額，並體現在稅單和後臺的統計表中。',
                title7: '07 交換班和現金管理',
                titleSub7: '員工上下班，現金核對困難？',
                con7: '每天上班提交收銀員和現金資料，交班後再次清點，系統會核算出應收金額和誤差金額，管理一目了然。',
                title8: '08 支持離線',
                titleSub8: '餐廳網路環境不好，信號中斷怎麼辦？',
                con8: 'Lettuce 收銀機擁有超大存儲空間，支援本地數據存儲和離線操作，不懼網路信號問題。在有網路的時候 ，同步數據，即可實現雲端管理。',
                title9: '09 支持中英文',
                titleSub9: '特殊餐廳需要中英文？',
                con9: '所有設備和後臺都支援中英文切換，方便閱讀和查看；標籤和單據的列印也能同時中英文，功能表展示更直觀。',
            }
        },
        con3:{
            // tit:'文章',
            // titSub:'生菜系統更新介紹，客戶案例，活動',
            // detail:'詳情',
            tit:'我們的客戶',
            titSub:'商場合作',
            detail: '已接通以下商場營業資料API介面 SM Mall、Ayala Malls'
        },
        con4: {
            tit1: '關於生菜',
            tit2: '生菜有限公司總部設在香港，研發中心成立於中國廈門、深圳；在菲律賓、馬來西亞均設有分公司。',
            titSub: 'Lettuce POS 為東南亞國家各種規模的餐飲企業，提供一站式的符合當地法律稅務、本地化POS餐飲系統解決方案，實現雲端管理及強大的運營資料分析能力，助力餐飲企業高速發展。'
        }
    },
    blog: {
        bannerText: '文章',
        bannerDetail: '生菜系統更新介紹，客戶案例，活動',
    },
    about: {
        bannerText: '關於我們',
        bannerDetail: '東南亞國家專業的智能餐飲系統製造商',
        tit: '關於生菜',
        detail1:'Lettuce  Limited 生菜有限公司，成立於2018年，總部設立於香港，在廈門、深圳、菲律賓、馬來西亞、泰國等均設有分公司以及營運中心。',
        detail2:'Lettuce 是東南亞國家最好用的餐飲系統之一，為東南亞國家各種規模的餐飲企業、商場、超市企業等，提供壹站式的符合當地法律稅務、本地化POS系統解決方案，實現雲端管理及強大的運營數據分析能力，助力餐飲企業、商場及超市企業高速發展。',
        detail3:'2018年進入菲律賓市場，短短三年時間，已經服務的實體商戶超過10000+，在菲律賓市場具有高度的影響力；2019年進入馬來西亞市場，並得到客戶的認可；2020年同時進入泰國和香港市場；預計 2021年進入印尼及緬甸市場；Lettuce 在東南亞國家已經服務的實體商戶超12000+。',
        detail4:'我們在東南亞國家與VISA 、MasterCard 、UnionPay銀聯、WechatPay微信支付、Alipay支付寶、BDO UNIBANK 、Paymaya 、GCash 、Yedpay 、QFPAY錢方、FUCENT GATEWAY富信、SM SUPERMALLS 、Ayala Malls  、Lazada、Shopee等達成戰略合作夥伴關係。'
    },
    contact: {
        bannerText: '聯繫我們',
        bannerDetail: '如果需要，請聯繫銷售人員或給我們留言。',
        contactNumber: {
            tit: '聯繫資訊',
            cnTel: '電話: +63-917-8836968',
            EnTel: '郵箱: salesph@nelsoft.com.ph / sales@nelsoft.com.ph',
            time: '聯繫人: LAW Roger',
        },
        contactAddress: {
            tit: '聯繫地址',
            address1: '地址:5th Floor #41 J. Mariano St., Corner EDSA Barangay 95, Caloocan City 1400',
            address2: '網址: www.lettuce.com.ph',
        },
        contactWechat: '微信',
        contactUs: {
            tit: '聯繫我們',
            tips: '我們很樂意幫助您快速安裝生菜以滿足您的業務需求。 留下您的商家資訊，我們友好的工作人員將儘快與您聯繫。',
            submitBtn: '提交'
        }
    },
    faq: {
        bannerText: '常見問題',
        bannerDetail: '若有其他疑問？請聯繫工作人員+63-917-8836968，歡迎您的諮詢',
        listName1: '產品和功能',
        listName2: '硬體和網路',
        listName3: '客戶支援',
        queList1: {
            title1: 'Lettuce是什麼？',
            title2: 'Lettuce 後臺是什麼？',
            title3: 'Lettuce POS是什麼？',
            title4: '生菜餐飲系統支援哪些場景呢？',
            title5: '支援生菜系統的設備？',
            title6: '我有多家門店，能統一管理嗎？',
            title7: '新店設置複雜嗎？如果有多家門店是否要重複設置？',
            title8: '如何更新Lettuce 收銀機點餐機的設置？',
            title9: 'Lettuce POS 支援哪些支付方式？',
            title10: '不同的管理員將如何分配使用功能？',
            detail1: 'Lettuce，是一款通過菲律賓國稅局BIR認證的餐飲收銀管理軟體，提供一站式地符合當地法律稅務、本地化餐飲解決方案，實現雲端管理，及強大的運營數據分析能力，助力餐飲企業高速發展。',
            detail2: 'Lettuce 後臺，是餐飲企業管理者對全部門店和經營情況進行管理的平臺，管理者可在後臺靈活對桌台、菜品、優惠活動、人員管理等進行配置；對門店經營資料、各式報表、人員交接班情況進行查看。',
            detail3: 'Lettuce POS，是門店中點餐、收銀的工具。通過配置，可實現多種場景點餐收銀功能，並對交易記錄、菜品銷售、人員交接等資料進行記錄和管理。',
            detail4: '1、速食店：支持快速點單，顧客下單並支付完成後，收銀員給顧客稅單，並給廚房列印菜品單據。\n 2、大型餐飲店：支援桌台管理，多台點餐機同時點餐，顧客下單後廚房列印菜品單據，用餐完成後進行結帳。\n3、奶茶小吃店：支援複雜商品設置，可設置商品的規格、口味、加料等資訊，並列印標籤。\n4、夜間經營餐館：支援跨天經營統計，並列印相應日結單據。',
            detail5: 'Lettuce將可在Lettuce匹配的收銀機、點餐機上使用。',
            detail6: '能，管理員登錄Lettuce 管理後臺，將可以對所有門店進行統一管理。',
            detail7: '很簡單，Lettuce的工作人員將會協助進行首次的門店設置。如果其他門店的設置情況與第一家門店類似，可以使用一鍵複製的功能，將設置複製到其他門店，同時也可以進行靈活修改。',
            detail8: '點擊數據同步按鈕（填寫步驟），即可將後臺的設置更新到收銀機。',
            detail9: '通用：支持現金、Visa、MasterCard、AMEX、UnionPay、BDO、PayMaya、WeChat Pay、Alipay等支付方式；\n定制化支付：可支援接入特殊商家的獨有支付方式。',
            detail10: 'Lettuce 後臺，能設置許可權角色（例如：收銀員、經理等）並分配給他們不同的功能，用戶無許可權使用未分配給他的功能。',
        },
        queList2: {
            title1: '安裝硬體需要哪些基礎條件？',
            title2: '如果在沒有網路的環境下，如何運營系統？',
            title3: '如何設置列印機？',
            title4: '如何解決常見的列印機問題？',
            detail1: '確保現場已有檯、電源和網路，安裝收銀機和所有列印機位置需有可放的檯位，電源插座和拉好網線並可上網，我們安裝人員會上門連接收銀機和列印機即可使用。',
            detail2: '收銀機、點餐機可在無網路情況下使用（路由器和網線需要保持正常狀態）；自助機需要在有網路情況下使用。',
            detail3: '1、首次安裝人員會設置好列印機IP\n2、在Lettuce 管理後臺-列印設置-添加列印機（根據提示輸入IP等資訊）\n3、收銀機、點餐機、自助機點擊數據更新，並查看列印機管理-顯示該列印機出於連接狀態即可。',
            detail4: '1 、檢查是否缺紙，紙張有沒有放反；\n 2、檢查路由器是否開啟，網線是否正常，列印機需要網線連接到路由器上；\n3、重啟列印機；\n4、如果硬體損壞請聯繫安裝人員。',
        },
        queList3: {
            title1: '如何獲得安裝指導和培訓？',
            title2: '售後服務包含哪些內容？',
            title3: '售後聯繫方式？',
            title4: '是否稅號申請和報稅服務？',
            detail1: '上門安裝，培訓，開業現場技術指導，總共免費3天。',
            detail2: '1、客服電話和遠端連接服務：週一至週五（9:00-18:00）不包含節假日。\n2、上門技術指導：大馬尼拉省內1000菲幣/天，省外2000菲幣/天,報銷路費和住宿費。\n3、硬體保修期為1年。',
            detail3: {},
            detail4: '包含申請收銀機稅務許可證，不包含幫客戶保稅繳稅。',
        }
    }
};



// WEBPACK FOOTER //
// ./src/langs/zh.js